{
  "INBOX_MGMT": {
    "HEADER": "Fiókok",
    "DESCRIPTION": "A csatorna az a kommunikációs mód, amelyet az ügyfél a kapcsolatfelvételhez választ. A postafiókban egy adott csatorna interakcióit kezeli. Ide tartozhatnak különböző forrásokból érkező üzenetek, például e-mail, élő chat és közösségi média.",
    "LEARN_MORE": "További információ a postafiókokról",
    "RECONNECT": {
      "BUTTON": "Újracsatlakozás",
      "FACEBOOK": "A Facebook-kapcsolat lejárt, vagy visszavonták. Az oldalnak küldött üzenetek nem érkeznek meg ebbe a postafiókba, és a válaszok elküldése sikertelen lehet. A Facebook-oldalt kezelő személynek az Újracsatlakozás gombra kell kattintania, és be kell jelentkeznie a Facebookba.",
      "INSTAGRAM": "Az Instagram-kapcsolat lejárt, vagy visszavonták. Az Instagram-fióknak küldött üzenetek nem érkeznek meg ebbe a postafiókba, és a válaszok elküldése sikertelen lehet. Kattintson az Újracsatlakozás gombra, és jelentkezzen be ugyanazzal az Instagram-fiókkal. Egy másik fiók új postafiókot hoz létre.",
      "GOOGLE": "A Google-kapcsolat lejárt, vagy visszavonták. Az új e-mailek nem érkeznek meg ebbe a postafiókba, és a válaszok elküldése sikertelen lehet. Kattintson az Újracsatlakozás gombra, és jelentkezzen be a Google-ba ezzel a címmel: {email}.",
      "MICROSOFT": "A Microsoft-kapcsolat lejárt, vagy visszavonták. Az új e-mailek nem érkeznek meg ebbe a postafiókba, és a válaszok elküldése sikertelen lehet. Kattintson az Újracsatlakozás gombra, és jelentkezzen be a Microsoftba ezzel a címmel: {email}.",
      "ALLEGRO": "Az Allegro-kapcsolat lejárt, vagy visszavonták. A vásárlók üzenetei nem érkeznek meg ebbe a postafiókba, és a válaszok elküldése sikertelen lehet. Kattintson az Újracsatlakozás gombra, és jelentkezzen be az Allegróba {seller} eladóként. Egy másik eladói fiók új postafiókot hoz létre.",
      "IMAP_LOGIN": "A levelezőszerver elutasítja a(z) {login} IMAP-bejelentkezést. Az új e-mailek nem érkeznek meg ebbe a postaládába. Ellenőrizze az IMAP-bejelentkezési nevet és jelszót a(z) {tab} lapon, majd mentse el őket. Tovább próbálkozunk a bejelentkezéssel, és a postaláda helyreáll, amint a bejelentkezés sikerül.",
      "WHATSAPP": "A WhatsApp-kapcsolat lejárt vagy visszavonták. Az ügyfelek mellékletei nem érkeznek meg ebbe a postafiókba, és a válaszok sikertelenek lehetnek. Kattintson az Újracsatlakozás gombra, jelentkezzen be a Facebookba, és válassza ki újra a(z) {phone} számot."
    },
    "LIST": {
      "404": "Nincs Inbox kapcsolva ehhez a fiókhoz.",
      "RECONNECT_REQUIRED": "Újracsatlakozás szükséges"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Csatorna kiválasztása",
        "BODY": "Válassza ki a szolgáltatót, amelyet integrálni szeretne a chattel."
      },
      "INBOX": {
        "TITLE": "Fiók létrehozása",
        "BODY": "Hitelesítsd a fiókod és hozz létre egy inboxot."
      },
      "AGENT": {
        "TITLE": "Ügynök Hozzádása",
        "BODY": "Adj hozzá ügynököket a létrehozott inboxhoz."
      },
      "FINISH": {
        "TITLE": "Kész is!",
        "BODY": "Mindennel készen állsz!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Fiók név",
        "PLACEHOLDER": "Írd be a postafiókod nevét",
        "ERROR": "Kérlek, adj meg egy érvényes postafiók nevet"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website név",
        "PLACEHOLDER": "Add meg weboldalad nevét (pl.: Példa Kft.)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Belső név",
        "PLACEHOLDER": "Adjon nevet a postafióknak, ahogy ebben az irányítópulton megjelenik",
        "ERROR": "Adjon meg egy egyedi belső nevet"
      },
      "FB": {
        "HELP": "UI: A bejelentkezésével csak az oldala üzeneteihez kapunk hozzáférést. Privát üzeneteihez soha nem férhetünk hozzá.",
        "CHOOSE_PAGE": "Oldal kiválasztása",
        "CHOOSE_PLACEHOLDER": "Válaszd ki az oldalt a listából",
        "INBOX_NAME": "Fiók név",
        "ADD_NAME": "Adj nevet a fiókodnak",
        "PICK_NAME": "Adjon nevet a postafióknak",
        "PICK_A_VALUE": "Válassz értéket",
        "CREATE_INBOX": "Postafiók létrehozása"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Folytatás Instagrammal",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Csatlakoztassa Instagram profilját",
        "HELP": "Instagram profiljának csatornaként való hozzáadásához hitelesítenie kell Instagram profilját a 'Folytatás Instagrammal' gombra kattintva ",
        "ERROR_MESSAGE": "Hiba történt az Instagramhoz való csatlakozás során, kérjük, próbálja újra",
        "ERROR_AUTH": "Hiba történt az Instagramhoz való csatlakozás során, kérjük, próbálja újra",
        "NEW_INBOX_SUGGESTION": "Ez az Instagram fiók korábban egy másik postafiókhoz volt kapcsolva, és most át lett migrálva ide. Minden új üzenet itt fog megjelenni. A régi postafiók a továbbiakban nem tud üzeneteket küldeni vagy fogadni ehhez a fiókhoz.",
        "DUPLICATE_INBOX_BANNER": "Ez az Instagram fiók át lett migrálva az új Instagram csatornás postafiókba. Ebből a postafiókból a továbbiakban nem tud Instagram üzeneteket küldeni/fogadni."
      },
      "TWITTER": {
        "HELP": "Ahhoz hogy hozzáadd a twitter profilodat egy csatornaként, azonosítanod kell a Twitter fiókodat a 'Belépés Twitterrel' gomb megnyomásával ",
        "ERROR_MESSAGE": "Hiba történt a Twitterrel való csatlakozáskor, kérjük próbáld később",
        "TWEETS": {
          "ENABLE": "Beszélgetés létrehozása az említett Tweetekből"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website csatorna",
        "DESC": "Hozz létre egy csatornát a websiteodnak és kezdd el az ügyfeleid támogatását a website widgeten keresztül.",
        "LOADING_MESSAGE": "Website támogatási csatorna létrehozása",
        "CHANNEL_AVATAR": {
          "LABEL": "Csatorna avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Adja meg a webhook URL-t",
          "ERROR": "Kérjük helyes URL-t adj meg"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website domain",
          "PLACEHOLDER": "Add meg weboldalad domainjét (pl.: példa.hu)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Köszöntő fejléc üzenet",
          "PLACEHOLDER": "Szia!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Köszöntő üzenet",
          "PLACEHOLDER": "Könnyűvé tesszük, hogy kapcsolatba kerülj velünk. Kérdezz bármit, vagy oszd meg véleményed."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Csatorna köszöntő üzenet",
          "PLACEHOLDER": "Példa Kft. általában néhány órán belül válaszol."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Csatorna köszöntés engedélyezése",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Engedélyezve",
          "DISABLED": "Letiltva"
        },
        "REPLY_TIME": {
          "TITLE": "Válaszadási idő megadása",
          "IN_A_FEW_MINUTES": "Néhány percen belül",
          "IN_A_FEW_HOURS": "Néhány órán belül",
          "IN_A_DAY": "Egy napon belül",
          "HELP_TEXT": "Ezen válaszidő ki lesz írva az élő chat widgeten"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget szín",
          "PLACEHOLDER": "Frissítsd a widget színét"
        },
        "SUBMIT_BUTTON": "Fiók létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem tudjuk újra megnyitni a weboldalt, kérlek, próbáld újra"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/Whatsapp csatorna",
        "DESC": "Twilio integrálása és ügyfelek támogatása SMS-en vagy a WhatsAppon keresztül",
        "ACCOUNT_SID": {
          "LABEL": "Fiók SID",
          "PLACEHOLDER": "Kérjük add meg a Twilio fiók SID-t",
          "ERROR": "Ez a mező kötelező"
        },
        "API_KEY": {
          "USE_API_KEY": "API kulcs hitelesítés",
          "LABEL": "API kulcs biztonsági azonosító (SID)",
          "PLACEHOLDER": "Írja be az API kulcs biztonsági azonosítót (SID)",
          "ERROR": "Ez a mező kötelező"
        },
        "API_KEY_SECRET": {
          "LABEL": "API titkos kulcs",
          "PLACEHOLDER": "Írja be az API kulcs biztonsági azonosítót (SID)",
          "ERROR": "Ez a mező kötelező"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Üzenetküldő szolgáltatás",
          "PLACEHOLDER": "Kérlek add meg a Twilio Üzenetküldő Szolgáltatás azonosítóját",
          "ERROR": "Ez a mező kötelező",
          "USE_MESSAGING_SERVICE": "Twilio Üzenetküldő használata"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Csatorna típusa",
          "ERROR": "Kérjük válaszd ki a csatorna típusát"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth token",
          "PLACEHOLDER": "Kérjük add meg a Twilio auth tokened",
          "ERROR": "Ez a mező kötelező"
        },
        "CHANNEL_NAME": {
          "LABEL": "Fiók név",
          "PLACEHOLDER": "Add meg a postafiók nevét",
          "ERROR": "Ez a mező kötelező"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonszám",
          "PLACEHOLDER": "Kérjük add meg a telefonszámot, amire az üzeneteket küldjük.",
          "ERROR": "Adj meg egy telefonszámot ami +-al kezdődik és nem tartalmaz szóközöket"
        },
        "API_CALLBACK": {
          "TITLE": "Visszahívás URL",
          "SUBTITLE": "Be kell állítanod az üzenet visszahívás URL-t a Twilion az itt megadott URL alapján."
        },
        "SUBMIT_BUTTON": "Twilio csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk hitelesíteni a Twilio fiókodat, kérjük próbáld később"
        }
      },
      "SMS": {
        "TITLE": "SMS csatorna",
        "DESC": "Ügyfelek támogatásának indítása SMS-en keresztül",
        "PROVIDERS": {
          "LABEL": "API szolgáltató",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Sávszélesség",
          "SMS_BRANA": "SMS Brána",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk menteni az SMS csatornáját"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Fiók Azonosító",
            "PLACEHOLDER": "Kérlek add meg a Bandwidth Fiók felhasználódat",
            "ERROR": "Ez a mező kötelező"
          },
          "API_KEY": {
            "LABEL": "API kulcs",
            "PLACEHOLDER": "Adja meg a Bandwidth API-kulcsot",
            "ERROR": "Ez a mező kötelező"
          },
          "API_SECRET": {
            "LABEL": "API titkos kulcs",
            "PLACEHOLDER": "Adja meg a Bandwidth API-titkot",
            "ERROR": "Ez a mező kötelező"
          },
          "APPLICATION_ID": {
            "LABEL": "Alkalmazás ID",
            "PLACEHOLDER": "Kérlek add meg a Bandwidth Jelentkezési felhasználódat",
            "ERROR": "Ez a mező kötelező"
          },
          "INBOX_NAME": {
            "LABEL": "Fiók név",
            "PLACEHOLDER": "Add meg a postafiók nevét",
            "ERROR": "Ez a mező kötelező"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonszám",
            "PLACEHOLDER": "Kérjük add meg a telefonszámot, amire az üzeneteket küldjük.",
            "ERROR": "Adj meg egy telefonszámot ami +-al kezdődik és nem tartalmaz szóközöket"
          },
          "SUBMIT_BUTTON": "Bandwidth csatorna létrehozása",
          "API": {
            "ERROR_MESSAGE": "Nem tudtuk hitelesíteni a sávszélesség hitelesítő adatait. Kérjük, próbáld újra"
          },
          "API_CALLBACK": {
            "TITLE": "Visszahívás URL",
            "SUBTITLE": "Be kell állítanod az üzenet visszahívási URL-jét a sávszélességben az itt említett URL-lel."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Postafiók neve",
            "PLACEHOLDER": "Adjon meg egy postafiók nevet",
            "ERROR": "Ez a mező kötelező"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonszám",
            "PLACEHOLDER": "Adja meg a telefonszámot, amelyről az üzenetek küldésre kerülnek.",
            "ERROR": "Adjon meg érvényes telefonszámot, amely `+` jellel kezdődik."
          },
          "SUBMIT_BUTTON": "SMS Brana csatorna létrehozása",
          "API": {
            "ERROR_MESSAGE": "Nem sikerült létrehozni az SMS Brana csatornát"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Postafiók neve",
            "PLACEHOLDER": "Adjon meg egy postafiók nevet",
            "ERROR": "Ez a mező kötelező"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonszám",
            "PLACEHOLDER": "Adja meg a telefonszámot, amelyről az üzenetek küldésre kerülnek.",
            "ERROR": "Adjon meg érvényes telefonszámot, amely `+` jellel kezdődik."
          },
          "SUBMIT_BUTTON": "DIDWW csatorna létrehozása",
          "API": {
            "ERROR_MESSAGE": "Nem sikerült létrehozni a DIDWW csatornát"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API szolgáltató",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Be kell állítania a webhook URL-címét és az ellenőrző tokent a Facebook fejlesztői portálon az alább látható értékekkel.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook ellenőrző token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Gyors beállítás a Metával",
          "DESC": "Átirányítjuk a Metához, hogy bejelentkezzen a WhatsApp Business-fiókjába. Rendszergazdai hozzáféréssel a beállítás gyors és egyszerű.",
          "BENEFITS": {
            "EASY_SETUP": "Nincs szükség kézi beállításra",
            "SECURE_AUTH": "Biztonságos, OAuth-alapú hitelesítés",
            "AUTO_CONFIG": "A webhook és a telefonszám automatikus beállítása"
          },
          "SUBMIT_BUTTON": "Csatlakozás a WhatsApp Businesszel",
          "AUTH_PROCESSING": "Hitelesítés a Metával",
          "WAITING_FOR_BUSINESS_INFO": "Fejezze be a vállalkozás beállítását a Meta ablakában...",
          "PROCESSING": "A WhatsApp Business-fiók beállítása",
          "CANCELLED": "A WhatsApp-regisztráció megszakadt",
          "WAITING_FOR_AUTH": "Várakozás a hitelesítésre...",
          "INVALID_BUSINESS_DATA": "A Facebooktól érvénytelen vállalkozási adatok érkeztek. Próbálja újra.",
          "SIGNUP_ERROR": "Hiba történt a regisztráció során",
          "SDK_LOAD_ERROR": "Nem sikerült betölteni a Facebook SDK-t. Kérjük, próbálja újra.",
          "AUTH_NOT_COMPLETED": "A hitelesítés nem fejeződött be. Kezdje újra a folyamatot.",
          "SUCCESS_FALLBACK": "A WhatsApp Business-fiók beállítása sikeres",
          "RECONNECTED": "A WhatsApp-csatorna sikeresen újracsatlakozott"
        },
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk elmenteni a WhatsApp csatornát"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API csatorna",
        "DESC": "API-val integrálj és láss neki az ügyfeleid támogatásának.",
        "CHANNEL_NAME": {
          "LABEL": "Csatorna neve",
          "PLACEHOLDER": "Kérjük adj meg csatorna nevet",
          "ERROR": "Ez a mező kötelező"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Adja meg az URL-t, amelyre az eseményekről szóló visszahívásokat kapni szeretné.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "API csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk elmenteni az API csatornát"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce csatorna",
        "DESC": "Integrálja a Salesforce csatornát és kezdje el támogatni ügyfeleit.",
        "CHANNEL_NAME": {
          "LABEL": "Csatorna neve",
          "PLACEHOLDER": "Adja meg a csatorna nevét",
          "ERROR": "Ez a mező kötelező"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Konfigurálja az alap URL-t a Salesforce példányhoz.",
          "PLACEHOLDER": "Salesforce API URL",
          "ERROR": "Ez a mező kötelező"
        },
        "KEY_ID": {
          "LABEL": "Kulcs azonosító",
          "SUBTITLE": "Kulcs azonosító a Salesforce csatornához.",
          "PLACEHOLDER": "KULCS AZONOSÍTÓ",
          "ERROR": "Ez a mező kötelező"
        },
        "SECRET": {
          "LABEL": "Titkos kulcs",
          "SUBTITLE": "Titkos kulcs a Salesforce csatornához.",
          "PLACEHOLDER": "*****",
          "ERROR": "Ez a mező kötelező"
        },
        "SUBMIT_BUTTON": "Salesforce csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem sikerült menteni a Salesforce csatornát"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "A webhook URL-t az itt megadott URL-lel kell konfigurálnia a Salesforce-ban."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer token",
          "SUBTITLE": "Használja ezt a bearer tokent a hitelesítéshez a webhook Salesforce-ban történő konfigurálásakor."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "E-mail feladó felülírása",
          "SUBTITLE": "Ha be van állítva, ez az e-mail cím lesz használva feladóként minden kimenő e-mailhez a beszélgetés forrás e-mailje helyett.",
          "PLACEHOLDER": "pl. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro csatorna",
        "DESC": "Csatlakoztasson egy Allegro eladói fiókot, és válaszoljon az üzeneteire a kontaktközpontból.",
        "CHANNEL_NAME": {
          "LABEL": "Postafiók neve",
          "SUBTITLE": "Ezt a nevet látják az ügynökök ennél a postafióknál.",
          "PLACEHOLDER": "Adjon meg egy postafiók nevet",
          "ERROR": "Ez a mező kötelező"
        },
        "SUBMIT_BUTTON": "Bejelentkezés Allegróval",
        "API": {
          "ERROR_MESSAGE": "Hiba történt az Allegróhoz való csatlakozás során, kérjük, próbálja újra"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro bejelentkezés",
          "SUBTITLE": "Az az eladói fiók, amelynek üzeneteit ez a postafiók olvassa és megválaszolja."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland csatorna",
        "DESC": "Válaszoljon azokra a ticket üzenetekre, amelyeket a vásárlók a Kaufland piactéren küldenek Önnek.",
        "CHANNEL_NAME": {
          "LABEL": "Csatorna neve",
          "PLACEHOLDER": "Adja meg a csatorna nevét",
          "ERROR": "Ez a mező kötelező"
        },
        "CLIENT_KEY": {
          "LABEL": "Kliens kulcs",
          "SUBTITLE": "A 32 karakteres Client Key a Kaufland eladói fiókjának API beállítások oldaláról.",
          "PLACEHOLDER": "32 karakteres kulcs",
          "ERROR": "Adja meg a 32 karakteres Client Key-t"
        },
        "SECRET_KEY": {
          "LABEL": "Titkos kulcs",
          "SUBTITLE": "A Client Key-hez tartozó 64 karakteres Secret Key. A Kaufland egyszer mutatja meg, és erre az oldalra soha nem kerül vissza.",
          "PLACEHOLDER": "64 karakteres kulcs",
          "ERROR": "Adja meg a 64 karakteres Secret Key-t"
        },
        "SUBMIT_BUTTON": "Kaufland csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem sikerült menteni a Kaufland csatornát"
        },
        "DISCONNECTED": {
          "TITLE": "Leválasztva",
          "MESSAGE": "A Kaufland elutasította ezeket az API kulcsokat. Adja meg újra a Client Key-t és a Secret Key-t a postafiók újracsatlakoztatásához."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-mail csatorna",
        "DESC": "Kapcsolja be az e-mail postafiókját.",
        "CHANNEL_NAME": {
          "LABEL": "Csatorna neve",
          "PLACEHOLDER": "Kérjük adj meg csatorna nevet",
          "ERROR": "Ez a mező kötelező"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "Az e-mail ahova az ügyfeled a támogatási kérelmeit küldi",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "E-mail csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk elmenteni az e-mail csatornát"
        },
        "FINISH_MESSAGE": "Kezdd el továbbítani az e-maileket a következő e-mail címekre."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE csatorna",
        "DESC": "Integrálj LINE csatornát az alkalmazásba.",
        "CHANNEL_NAME": {
          "LABEL": "Csatorna neve",
          "PLACEHOLDER": "Kérjük adj meg csatorna nevet",
          "ERROR": "Ez a mező kötelező"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE csatornaazonosító",
          "PLACEHOLDER": "LINE csatornaazonosító"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE csatornatitok",
          "PLACEHOLDER": "LINE csatornatitok"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE csatornatoken",
          "PLACEHOLDER": "LINE csatornatoken"
        },
        "SUBMIT_BUTTON": "LINE csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk menteni a LINE csatornát"
        },
        "API_CALLBACK": {
          "TITLE": "Visszahívás URL",
          "SUBTITLE": "A webhook URL-címét a LINE alkalmazásban az itt említett URL-lel kell konfigurálnia."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram csatorna",
        "DESC": "Integrálj Telegram csatornát az alkalmazásba.",
        "BOT_TOKEN": {
          "LABEL": "Bot token",
          "SUBTITLE": "Konfigurálja a Telegram BotFathertől kapott bot tokent.",
          "PLACEHOLDER": "Bot token"
        },
        "SUBMIT_BUTTON": "Telgram csatorna létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem tudtuk elmenteni a Telegram csatornát"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonhívások",
        "DESC": "Állítsa be, mely telefonhívások jelenjenek meg ebben a postafiókban.",
        "NAME": {
          "LABEL": "Postafiók neve",
          "SUBTITLE": "Válasszon könnyen azonosítható nevet."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonszám",
          "SUBTITLE": "Adja meg a postafiókhoz tartozó telefonszámokat, később további számokat adhat hozzá.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Telefonhívások postafiók létrehozása",
        "API": {
          "ERROR_MESSAGE": "Nem sikerült létrehozni a postafiókot"
        }
      },
      "AUTH": {
        "TITLE": "Csatorna kiválasztása",
        "DESC": "A chat csatornaként támogatja az élő chat widgeteket, a Facebook Messengert, a WhatsAppot, az e-maileket stb. Ha egyedi csatornát szeretne létrehozni, az API-csatornával teheti meg. A kezdéshez válasszon az alábbi csatornák közül."
      },
      "AGENTS": {
        "TITLE": "Ügynökök",
        "DESC": "Itt hozzáadhatsz ügynököket az újonan létrehooztt inboxodhoz. Csak ezek a kiválasztott ügynökök fognak hozzáférni az inboxodhoz. Az ügynökök akik nem részei az inboxnak, nem látják és nem tudnak válaszolni az üzenetekre belépésük után. <br><b>UI:</b>Adminisztrátorként hozzáférésed van az összes inboxhoz, add hozzá magad az összes inboxhoz ügynökként.",
        "VALIDATION_ERROR": "Adjon legalább egy ügynököt az új postafiókhoz",
        "PICK_AGENTS": "Válaszd ki az inboxhoz hozzárendelt ügynököket"
      },
      "DETAILS": {
        "TITLE": "Fiók részletek",
        "DESC": "A legördülő listából válassza ki, melyik Facebook-oldalt szeretné a chathez kötni. Egyedi nevet is adhat az Inboxnak a jobb azonosíthatóság érdekében."
      },
      "FINISH": {
        "TITLE": "Sikerült!",
        "DESC": "Sikeresen integrálta Facebook-oldalát a chattel. Legközelebb, amikor egy ügyfél üzenetet ír az oldalára, a beszélgetés automatikusan megjelenik az inboxában.<br> Ezen kívül egy widget kódot biztosítunk Önnek, amelyet könnyen hozzáadhat a weboldalához. Amint ez élesítésre kerül, az ügyfelek üzenetet küldhetnek Önnek a weboldaláról bármilyen külső eszköz igénybevétele nélkül, és a beszélgetés itt, a chatben fog megjelenni. <br>Menő, nem? Hát megpróbáljuk :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Add meg az email szolgáltatód",
        "DESCRIPTION": "Válasszon egy e-mail szolgáltatót az alábbi listából. Ha nem látja az e-mail szolgáltatóját a listában, válassza a másik szolgáltató lehetőséget, és adja meg az IMAP és SMTP hitelesítő adatokat."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft e-mail",
        "DESCRIPTION": "A kezdéshez kattintson a Bejelentkezés a Microsofttal gombra. A rendszer átirányítja az e-mail bejelentkezési oldalra. Miután elfogadta a kért engedélyeket, a rendszer visszairányítja a beérkező levelek létrehozásának lépéséhez.",
        "EMAIL_PLACEHOLDER": "E-mailcím megadása",
        "SIGN_IN": "Bejelentkezés Microsofttal",
        "ERROR_MESSAGE": "Hiba történt a Microsoft szervereihez való csatlakozáskor, kérjük próbáld később"
      },
      "GOOGLE": {
        "TITLE": "Google e-mail",
        "DESCRIPTION": "Kezdésként kattintson a Bejelentkezés Google-lel gombra. Átirányítjuk az e-mail bejelentkezési oldalra. Miután elfogadta a kért engedélyeket, visszairányítjuk a postafiók létrehozásának lépéséhez.",
        "SIGN_IN": "Bejelentkezés Google-lel",
        "EMAIL_PLACEHOLDER": "E-mailcím megadása",
        "ERROR_MESSAGE": "Hiba történt a Google-hoz való csatlakozáskor, próbálja újra"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Facebookkal azonosítunk...",
      "ERROR_FB_LOADING": "Hiba történt a Facebook SDK betöltésekor. Kapcsolja ki a reklámblokkolókat, és próbálja újra egy másik böngészőből.",
      "ERROR_FB_AUTH": "Valami elromlott, kérjük töltsd újra az oldalt...",
      "ERROR_FB_UNAUTHORIZED": "Nincs jogosultsága erre a tevékenységre. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Bizonyosodjon meg, hogy teljes hozzáférése van a Facebook oldalhoz. Bővebb információt <a href=\" https://www.facebook.com/help/187316341316631\">itt talál</a>.",
      "ERROR_CHANNEL_CREATION": "Nem sikerült létrehozni a postafiókot. Kérjük, próbáld újra.",
      "CREATING_CHANNEL": "Inbox létrehozása...",
      "TITLE": "Inbox részletek beállítása",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Ügynök Hozzádása",
      "ADD_AGENTS": "Ügynökök hozzáadása a fiókhoz..."
    },
    "FINISH": {
      "TITLE": "A fiókod elkészült!",
      "MESSAGE": "Most már tudsz egyeztetni az ügyfeleiddel az új csatornán. Boldog támgoatást",
      "BUTTON_TEXT": "Vigyél oda",
      "MORE_SETTINGS": "További beállítások",
      "WEBSITE_SUCCESS": "Sikeresen létrehoztad a website csatornát. Másold az itt látható kódot és helyezd el a weboldaladon. Legközelebb, mikor egy ügyfél az élő chatben van, a beszélgetés automatikusan megjelenik az inboxodban."
    },
    "REAUTH": "Újraengedélyezés",
    "VIEW": "Megtekintés",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox beállítások sikeresen frissítve",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatikus hozzárendelés sikeresen frissítve",
        "ERROR_MESSAGE": "Nem tudtuk frissíteni a beérkező levelek beállításait. Kérlek, próbáld újra később."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Küldő neve",
        "SUB_TEXT": "Válassza ki a nevet, amelyet az ügyfél lát, amikor e-mailt kap az ügynököktől.",
        "FOR_EG": "Például:",
        "FRIENDLY": {
          "TITLE": "Barátságos",
          "FROM": "innen",
          "SUBTITLE": "Adja hozzá a feladó nevéhez a választ küldő ügynök nevét, hogy a válasz személyes hangvételű legyen."
        },
        "PROFESSIONAL": {
          "TITLE": "Professzionális",
          "SUBTITLE": "Csak a konfigurált cégnevet használja feladói névként az e-mail fejlécében."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Üzleti nevének konfigurálása",
          "PLACEHOLDER": "Adja meg vállalkozásának nevét",
          "SAVE_BUTTON_TEXT": "Mentés"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Nincs"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "ENABLE_HMAC": {
        "LABEL": "Engedélyezés"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Engedélyezve",
        "DISABLED": "Letiltva"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Bejövő e-mailek szinkronizálásának engedélyezése"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Egyéni e-mail domain engedélyezése (fizetős szolgáltatás)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Facebook hozzászólások feldolgozásának engedélyezése"
      },
      "SIGNATURE": {
        "TITLE": "HTML aláírás",
        "SUB_TEXT": "Ez az aláírás minden, ebből a postafiókból küldött üzenet láblécéhez hozzáadásra kerül.",
        "HTML_CONTENT": "HTML kód",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} helyére az ügynök neve kerül.\n{'{{'}email{'}}'} helyére az e-mailt küldő ügynök e-mail címe kerül.\n{'{{'}position{'}}'} helyére az ügynök beosztása kerül.\n{'{{'}custom_line{'}}'} helyére az ügynök egyéni sora kerül.\n{'{{'}email_signature_picture{'}}'} helyére az ügynök e-mail aláírásképének URL-címe kerül (nem képcímke) — használja képforrásként (egy img címke src attribútumaként).",
        "PREVIEW": "Előnézet"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Aláírások országok szerint",
        "SUB_TEXT": "A válasz a vásárló országának megfelelő aláírást kapja.",
        "HELP": "A válasz aláírása a beszélgetés országától függ: a Kaufland áruház, az Allegro-rendelés piactere, ennek hiányában a vásárló által használt nyelv alapján. Ha az ország ismeretlen, vagy nincs hozzá itt aláírás, a fenti HTML aláírás kerül felhasználásra. A piacterek tiltják a weboldalra mutató hivatkozásokat és az elérhetőségi adatokat, ezért csak egy üdvözlést és a(z) {'{{'}name{'}}'} értéket tüntesse fel.",
        "EMPTY": "Még nincs országspecifikus aláírása, ezért a válaszok a fenti HTML aláírást kapják.",
        "COUNTRY": "Válasszon országot",
        "ADD": "Országspecifikus aláírás hozzáadása",
        "REMOVE": "Eltávolítás"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Telefonszám tárcsázási előtag",
        "PLACEHOLDER": "Adja meg az előtagot a helyes hívásirányításhoz (pl. *99)",
        "HELP_TEXT": "Ez az előtag automatikusan a kapcsolattartó telefonszámai elé kerül, amikor ebből a postafiókból tárcsáz."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "„Később megoldjuk” gomb szövege",
        "PLACEHOLDER": "pl. Ezt a témát e-mailben oldjuk meg. Most szeretnék valami másról kérdezni.",
        "HELP_TEXT": "A widgetben megjelenő gomb felirata, amellyel a látogató elhagyja az aktuális témát, és valami másról kérdezhet. Ha üresen hagyja, a látogató nyelvén megadott alapértelmezett szöveg jelenik meg."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Nem fogadott hívások automatikus halasztása X percre",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Nem fogadott hívások automatikus halasztása megadott percre. Hagyja üresen vagy 0 a letiltáshoz."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Nem fogadott hívás lezárása X sikertelen visszahívás után",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Ha egy nem fogadott hívást X alkalommal visszahívtak, de az ügyfél nem vette fel, a hívás automatikusan megoldottra áll, és egy privát megjegyzés kerül hozzá. Hagyja üresen vagy 0 a letiltáshoz."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Kérdés javaslatok",
        "SUB_TEXT": "Konfiguráljon előre meghatározott kérdéseket, amelyeket az ügyfelek használhatnak az ügynökökkel való interakcióhoz.",
        "QUESTIONS_LABEL": "Kérdések",
        "ADD_QUESTION": "Kérdés hozzáadása",
        "QUESTION": "Kérdés",
        "REMOVE": "Eltávolítás",
        "QUESTION_TEXT": "A buborékban megjelenő szöveg.",
        "QUESTION_TEXT_PLACEHOLDER": "Kötelező",
        "QUESTION_PAYLOAD": "Kattintáskor elküldött szöveg.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opcionális",
        "SAVE": "Mentés",
        "NO_BOT_MESSAGE": "További AI javaslatok generálásához csatlakoztasson egy botot.",
        "BOT_CONNECTED_MESSAGE": "A bot AI kérdés javaslatai aktiválhatók a bot",
        "BOT_SETTINGS_LINK": "beállításaiban"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatív e-mail-címek",
        "SUB_TEXT": "További címek, amelyeket ennek a postaládának a sajátjaként kell kezelnie a továbbított levelek fogadásakor.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Hozzáadás",
        "REMOVE": "Eltávolítás",
        "EMPTY": "Nincsenek beállítva alternatív e-mail-címek.",
        "HELP_TEXT": "Amikor egy e-mail érkezik, amelynek címzettje ezen címek egyike, a válaszok ugyanazzal a címmel kerülnek elküldésre feladóként. Győződjön meg arról, hogy a kimenő SMTP-kiszolgálója engedélyezi a küldést ezekről a címekről.",
        "SIGNATURE_LABEL": "Aláírás",
        "PRIMARY_SIGNATURE": "Elsődleges (alapértelmezett)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "További aláírások",
        "SUB_TEXT": "Itt adhat meg további aláírásokat, majd rendelje hozzá őket az alábbi alternatív e-mail-címekhez.",
        "OPTION": "Aláírás {number}",
        "ADD": "Aláírás hozzáadása",
        "REMOVE": "Eltávolítás",
        "HELP_TEXT": "Amikor egy választ alternatív e-mail-címről küldenek, a hozzá rendelt aláírás lesz használva a postafiók aláírása helyett. A „Elsődleges (alapértelmezett)” beállításon hagyott alternatív e-mail-címek a postafiók aláírását használják."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "AVATAR_DELETE_BUTTON_TEXT": "Avatár Törlése",
      "DELETE_REQUESTED_TOOLTIP": "Ez a postafiók törlésre van megjelölve",
      "RESTORE_BUTTON_TEXT": "Visszaállítás",
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztos abban, hogy törli ",
        "PLACE_HOLDER": "Kérlek gépeld be, hogy {inboxName} a megerősítéshez",
        "YES": "Igen, Törlés ",
        "NO": "Nem, Mégse "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox sikeresen törölve",
        "MARKED_FOR_DELETION_MESSAGE": "A postafiók törlésre lett megjelölve",
        "RESTORE_SUCCESS_MESSAGE": "A postafiók sikeresen visszaállítva",
        "ERROR_MESSAGE": "Nem sikerült a fiók törlése. Kérjük próbáld később.",
        "RESTORE_ERROR_MESSAGE": "Nem sikerült visszaállítani a postafiókot. Kérjük, próbálja újra később.",
        "AVATAR_SUCCESS_MESSAGE": "Fiók avatar sikeresen törölve",
        "AVATAR_ERROR_MESSAGE": "A fiók avatar törlése nem lehetséges. Kérjük próbáld később."
      }
    },
    "TABS": {
      "SETTINGS": "Beállítások",
      "COLLABORATORS": "Csapattagok",
      "AUTOMATIC_PRIORITY": "Automatikus prioritás",
      "AUTOMATIC_LABELING": "Automatikus címkézés",
      "CONFIGURATION": "Beállítások",
      "CAMPAIGN": "Kampányok",
      "PRE_CHAT_FORM": "Chat előtti űrlap",
      "BUSINESS_HOURS": "Nyitvatartás",
      "WIDGET_BUILDER": "Widget építő",
      "BOT_CONFIGURATION": "Bot konfiguráció",
      "SLA": "SLA"
    },
    "SETTINGS": "Beállítások",
    "FEATURES": {
      "LABEL": "Lehetőségek",
      "DISPLAY_FILE_PICKER": "File választó megjelenítése a widgeten",
      "DISPLAY_EMOJI_PICKER": "Emoji választó megjelenítése a widgeten",
      "ALLOW_END_CONVERSATION": "Lehetővé teszi a felhasználóknak, hogy befejezzék a beszélgetést a widgetből",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Az 'Új beszélgetés indítása' gomb megjelenítése a widget fejlécében",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Beviteli mező elrejtése, ha az új beszélgetés indítása gomb látható",
      "SHOW_HANDOFF_BUTTON": "Az 'Átirányítás operátorhoz' gomb megjelenítése a widget fejlécében",
      "USE_INBOX_AVATAR_FOR_BOT": "Használja a fiók nevét és avatárját a bothoz",
      "ALLOW_OFFLINE_REPLY": "Ügynökök számára üzenetek küldésének engedélyezése, amikor a kapcsolattartó offline és az e-mail folytonosság nem elérhető",
      "AUTO_CLOSE_OLD": "Az azonos számról érkező összes korábbi hívás lezárt állapotúra jelölése, ha egyet lezárnak",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Nem fogadott hívások automatikus hozzárendelése kimenő hívás kezdeményezésekor"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger szkript",
      "MESSENGER_SUB_HEAD": "Ezt a gombot a body tag-en belül helyezd el",
      "INBOX_AGENTS": "Ügynökök",
      "INBOX_TEAMS": "Csapatok",
      "INBOX_COOPERATORS": "Együttműködők",
      "SELECT_PLACEHOLDER": "Válasszon",
      "AGENTS_OR_TEAMS_INFO": "Ügynököket vagy csapatokat rendelhet hozzá - nem egyszerre mindkettőt.",
      "AGENT_ASSIGNMENT": "Beszélgetés hozzárendelés",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Beszélgetés hozzárendelés beállítások frissítése",
      "UPDATE": "Frissítés",
      "ENABLE_EMAIL_COLLECT_BOX": "E-mail gyűjtődoboz engedélyezése",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Az e-mailek gyűjtődobozának engedélyezése vagy letiltása új beszélgetéseknél",
      "AUTO_ASSIGNMENT": "Automata hozzárendelés engedélyezése",
      "ENABLE_CSAT": "CSAT engedélyezése",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "CSAT engedélyezése minden üzenetnél",
      "SENDER_NAME_SECTION": "Ügynök nevének engedélyezése e-mailben",
      "ENABLE_CSAT_SUB_TEXT": "A CSAT (Ügyfél-elégedettség) felmérés engedélyezése/letiltása egy beszélgetés megoldása után",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "CSAT felmérés opció engedélyezése/letiltása minden ügynök által küldött üzenethez",
      "SENDER_NAME_SECTION_TEXT": "Az ügynök nevének megjelenítésének engedélyezése/letiltása az e-mailben, ha le van tiltva, akkor a cég neve jelenik meg",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Beszélgetés folytatásának engedélyezése emailen keresztül",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "A beszélgetések e-mailben folytatódnak, ha elérhető a kapcsolattartási e-mail cím.",
      "RESPOND_FROM_EMAIL": "Válasz e-mailből",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Az ügyfélnek szóló e-maileket – a válaszokat és a beszélgetés-átiratokat is – a kiválasztott e-mail postafiók SMTP-beállításaival, a kiválasztott címről (a postafiók saját címéről vagy valamelyik aliaszáról) küldjük, az ügyfél válaszai pedig annak IMAP-címén keresztül érkeznek vissza.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "A beszélgetés-átiratokat a kiválasztott e-mail postafiók SMTP-beállításaival, a kiválasztott címről (a postafiók saját címéről vagy valamelyik aliaszáról) küldjük, a válaszok pedig annak IMAP-címén keresztül érkeznek vissza.",
      "SHOW_WELCOME_SCREEN": "Üdvözlő képernyő megjelenítése",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Üdvözlő képernyő megjelenítése a vidzset megnyitásakor. Ha letiltva, a vidzset közvetlenül a beszélgetés nézetére ugrik.",
      "AUTO_CLOSE_PENDING": "AI csevegések automatikus lezárása (órák)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "AI csevegések automatikus lezárása X óra inaktivitás után.",
      "LOCK_TO_SINGLE_CONVERSATION": "Egyetlen beszélgetés zárolása",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Több beszélgetés engedélyezése vagy letiltása ugyanahhoz a névjegyhez ebben a postafiókban",
      "INBOX_UPDATE_TITLE": "Fiókbeállítások",
      "INBOX_UPDATE_SUB_TEXT": "Frissítsd az inbox beállításaidat",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Bekapcsolása vagy kikapcsolása az inboxhoz kapcsolódó automatikus ügynökhozzárendelésnek új beszélgetések esetén.",
      "HMAC_VERIFICATION": "Felhasználói fiók validálás",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Kulcs cseréje",
        "TITLE": "Lecseréled a titkos kulcsot?",
        "WARNING": "A jelenlegi kulcs azonnal érvényét veszti, amint kicseréled.",
        "WARNING_DETAIL": "Nincs átfedési időszak, és nem állítható vissza.",
        "IMPACT": "A szervereidnek az új kulccsal kell aláírniuk a felhasználókat. Aki még mindig a régi kulccsal van aláírva, nem megy át az ellenőrzésen. Ha a fiók validálása kötelező, nem tudnak beszélgetést indítani.",
        "CONFIRM": "Kulcs cseréje",
        "CANCEL": "Mégse",
        "SUCCESS": "A titkos kulcs sikeresen lecserélve",
        "ERROR": "Nem sikerült lecserélni a titkos kulcsot, kérjük próbáld újra"
      },
      "HMAC_LINK_TO_DOCS": "Bővebben itt olvashat.",
      "HMAC_MANDATORY_VERIFICATION": "Felhasználói fiók validálás kényszerítése",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Új beszélgetés kényszerítése a widget minden betöltésekor",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ha engedélyezve van, a widget új lapon vagy ablakban való megnyitása új beszélgetést indít.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Kapcsolat elfelejtése új beszélgetés indításakor",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ha le van tiltva, a widgetből indított új beszélgetés megtartja az előző kapcsolatot.",
      "INBOX_IDENTIFIER": "Fiók azonosító",
      "INBOX_IDENTIFIER_SUB_TEXT": "Használja az itt látható \"inbox_identifier\" tokent az API-kliensek hitelesítéséhez.",
      "FORWARD_EMAIL_TITLE": "Továbbítás ide",
      "FORWARD_EMAIL_SUB_TEXT": "Kezdd el továbbítani az e-maileket a következő e-mail címekre.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-mail szinkronizáció",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Bejövő e-mailek automatikus szinkronizálásának és letöltésének engedélyezése ebből a postafiókból",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Egyéni e-mail domain",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Engedélyezze egyéni e-mail domain használatát kimenő e-mailekhez",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Itt többet olvashat.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook hozzászólások",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Üzenetek engedélyezése a beszélgetés befejezése után",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Engedélyezze a végfelhasználók számára, hogy üzeneteket küldjenek a beszélgetés lezárása után is.",
      "WIDGET_STATUS_LABEL": "Vidzset állapota",
      "WIDGET_STATUS_ENABLED": "Engedélyezve",
      "WIDGET_STATUS_BUSINESS_HOURS": "Munkaidőben engedélyezve",
      "WIDGET_STATUS_DISABLED": "Letiltva",
      "WIDGET_STATUS_HELP_TEXT": "Szabályozza, mikor jelenjen meg a vidzset a webhely látogatóinak",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Csevegés előtti űrlap beállításainak frissítése",
      "EXPLICIT_CSAT_LOCALE": "CSAT felmérés és e-mail nyelv",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Válassza ki az ügyfél e-mailek, beleértve a CSAT felmérések, beszélgetés átiratok és e-mail értesítések nyelvét",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "A fiók beállítása szerint",
      "INBOX_AGENTS_SUB_TEXT": "Ügynökök hosszáadása vagy eltávolítása az inboxból",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-kapcsolat",
        "SUBTITLE": "Így kapcsolódik ez a postafiók a WhatsApphoz.",
        "PROVIDER": "Szolgáltató",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "A Meta beágyazott regisztrációjával csatlakoztatva",
        "STATUS": "Állapot",
        "CONNECTED": "Csatlakoztatva",
        "RECONNECT_HINT": "Kattintson az Újracsatlakozás gombra a fenti értesítésben.",
        "PHONE_NUMBER": "Telefonszám",
        "BUSINESS_ACCOUNT": "WhatsApp Business-fiók azonosítója",
        "OPEN_MANAGER": "Megnyitás a WhatsApp Managerben",
        "PHONE_NUMBER_ID": "Telefonszám-azonosító",
        "TEMPLATES": "Üzenetsablonok",
        "TEMPLATES_COUNT": "{total} sablonból {approved} jóváhagyva",
        "TEMPLATES_SYNCED": "Utolsó szinkronizálás: {date}",
        "TEMPLATES_NOT_SYNCED": "Még nincs szinkronizálva",
        "MANAGE_TEMPLATES": "Sablonok kezelése"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Súgóközpont",
      "PLACEHOLDER": "Súgóközpont kiválasztása",
      "SELECT_PLACEHOLDER": "Súgóközpont kiválasztása",
      "REMOVE": "Súgóközpont eltávolítása",
      "SUB_TEXT": "Súgóközpont csatolása a fiókhoz"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Automatikus hozzárendelés limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Kérlek 0-nál magasabb értéket adj meg",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Korlátozza az ebből a postafiókból érkező beszélgetések maximális számát, amelyek automatikusan hozzárendelhetők egy ügynökhöz"
    },
    "SLA": {
      "TITLE": "SLA szabályok",
      "SUB_TEXT": "Konfiguráljon SLA válasz- és megoldási időt minden beszélgetési prioritási szinthez.",
      "LOADING": "SLA szabályok betöltése...",
      "FIELDS": {
        "ACTIVE": "Aktív",
        "TICKET_PRIORITY": "Jegy prioritás",
        "FIRST_RESPONSE_TIME": "Első válasz idő",
        "EVERY_RESPONSE_TIME": "Minden válasz idő",
        "RESOLUTION_TIME": "Megoldási idő",
        "PLACEHOLDER": "pl. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA szabályok sikeresen frissítve.",
        "ERROR_MESSAGE": "Nem sikerült frissíteni az SLA szabályokat. Kérjük, próbálja újra."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatikus prioritás",
      "SUB_TEXT": "Konfigurálja az automatikus prioritás hozzárendelést a beszélgetés tartalma alapján.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Számlázási értesítés",
        "MESSAGE": "Minden prioritás kiértékelés díjköteles. Az árakért tekintse át a csomagja részleteit."
      },
      "MODE": {
        "OFF": "Ki",
        "ALL_MESSAGES": "Be az összes bejövő üzenetre",
        "FIRST_MESSAGE": "Be csak az első bejövő üzenetre"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Prioritási szint konfiguráció",
        "SUB_TEXT": "Konfigurálja, mely prioritási szintek legyenek engedélyezettek, és azok leírását. Adjon meg egyértelmű feltételeket, amelyek alapján az AI eldönti, mikor kell ezt a prioritást hozzárendelni."
      },
      "DESCRIPTION_LABEL": "Leírás",
      "DESCRIPTION_PLACEHOLDER": "Írja le a(z) {priority} prioritásként megjelölendő beszélgetéseket",
      "SET_AS_DEFAULT": "Beállítás alapértelmezett prioritásként",
      "MULTIPLE_DEFAULTS_WARNING": "Csak egy prioritási szintet lehet alapértelmezettként beállítani. Kérjük, vegye ki a többi alapértelmezett jelölését."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatikus címkézés",
      "SUB_TEXT": "Konfigurálja az automatikus címke hozzárendelést a beszélgetés tartalma alapján.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Számlázási értesítés",
        "MESSAGE": "Minden címkézés kiértékelés díjköteles. Az árakért tekintse át a csomagja részleteit."
      },
      "MODE": {
        "OFF": "Ki",
        "CONVERSATION_OPEN": "Beszélgetés megnyitásakor",
        "CONVERSATION_CLOSE": "Beszélgetés lezárásakor",
        "ALL_MESSAGES": "Minden üzenetre - állapottól függetlenül",
        "FIRST_MESSAGE": "Első üzenetre - állapottól függetlenül"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Címke konfiguráció",
        "SUB_TEXT": "Konfigurálja, mely címkék legyenek elérhetők automatikus hozzárendeléshez, és azok leírását. Adjon meg egyértelmű feltételeket, amelyek alapján az AI eldönti, mikor kell ezt a címkét alkalmazni."
      },
      "DESCRIPTION_LABEL": "Leírás",
      "DESCRIPTION_PLACEHOLDER": "Írja le a(z) {label} címkével ellátandó beszélgetéseket. Ha üresen hagyja, a címke leírása kerül felhasználásra.",
      "NO_LABELS_MESSAGE": "Nem találhatók címkék. Hozzon létre címkéket először az automatikus címkézés engedélyezéséhez.",
      "CREATE_LABELS_LINK": "Címkék létrehozása"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Újraengedélyezés",
      "SUBTITLE": "A Facebook kapcsolatod lejárt, kérjük kapcsold össze oldalad újra a szolgáltatás folytatásához",
      "MESSAGE_SUCCESS": "Újrakapcsolódás sikeres",
      "MESSAGE_ERROR": "Hiba történt, kérjük próbáld újra"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "A chat előtti űrlapok lehetővé teszik hogy felhasználói adatokat gyűjts mielőtt a beszélgetés megkezdődik.",
      "SET_FIELDS": "Csevegés előtti űrlapmezők",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Mezők",
        "LABEL": "Cimke",
        "PLACE_HOLDER": "Helykitöltő",
        "KEY": "Kulcs",
        "TYPE": "Típus",
        "REQUIRED": "Kötelező"
      },
      "ENABLE": {
        "LABEL": "Chat előtti űrlap engedélyezése",
        "OPTIONS": {
          "ENABLED": "Igen",
          "DISABLED": "Nem"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Chat előtti üzenet",
        "PLACEHOLDER": "Ez az üzenet látható lesz a felhasználók számára az űrlappal együtt"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "A látogatóknak nevük és e-mailcímük megadása szükséges a beszélgetés megkezdése előtt"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Elérhetőség beállítása",
      "SUBTITLE": "Állításd be az elérhetőséged idejét a chat widgeten",
      "WEEKLY_TITLE": "Heti órák beállítása",
      "TIMEZONE_LABEL": "Időzóna kiválasztása",
      "UPDATE": "Nyitvatartási idő beállítások szerkesztése",
      "TOGGLE_AVAILABILITY": "Nyitvatartási idő beállítások engedélyezése erre az inboxra",
      "UNAVAILABLE_MESSAGE_LABEL": "Nem elérhető üzenetek a vendégek számára",
      "TOGGLE_HELP": "Ha bekapcsolja az elérhetőséget, az élő chat widget akkor is mutatja a nyitvatartási időt, ha minden ügynök offline. A nyitvatartási időn kívül a látogatók üzenetet és csevegés előtti űrlapot láthatnak.",
      "DAY": {
        "ENABLE": "Elérhetőség bekapcsolása erre a napra",
        "UNAVAILABLE": "Nem elérhető",
        "HOURS": "óra",
        "VALIDATION_ERROR": "A kezés idejének a zárás ideje előttinek kell lennie.",
        "CHOOSE": "Kiválasztás"
      },
      "ALL_DAY": "Egész nap",
      "SAVE_TO_ALL": "Mentés az összes postafiókba",
      "SAVE_TO_ALL_TITLE": "Munkaidő másolása",
      "SAVE_TO_ALL_CONFIRM": "Az űrlap beállításai (elérhetőség kapcsoló, házon kívüli üzenet, időzóna és munkaidő) az összes többi postafiókba másolásra kerülnek, kivéve az e-mail és telefon postafiókokat. Biztosan folytatni szeretné?",
      "SAVE_TO_ALL_CANCEL": "Mégse",
      "SAVE_TO_ALL_YES": "Igen, másolás mindbe",
      "SAVE_TO_ALL_SUCCESS": "Munkaidő sikeresen átmásolva az összes többi postafiókba",
      "SAVE_TO_ALL_ERROR": "Nem sikerült átmásolni a munkaidőt más postafiókokba"
    },
    "PHONE": {
      "TITLE": "Telefon beállítások",
      "SUBTITLE": "Állítsa be, mely hívások jelenjenek meg ebben a postafiókban.",
      "UPDATE": "Beállítások mentése",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefon beállítások frissítve",
        "ERROR_MESSAGE": "Nem sikerült frissíteni a telefon beállításokat"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonszámok",
        "SUBTITLE": "Adja meg a postafiókhoz tartozó telefonszámokat.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Telefonszám hozzáadása"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "IMAP hozzáférés beállítása",
      "NOTE_TEXT": "Az SMTP engedélyezéséhez konfigurálja az IMAP-et.",
      "UPDATE": "IMAP beállítások frissítése",
      "TOGGLE_AVAILABILITY": "Engedélyezze az IMAP-konfigurációt ehhez a fiókhoz",
      "TOGGLE_HELP": "Az IMAP bekapcsolásával a felhasználó e-maileket fogadhat",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP beállítások sikeresen frissítve",
        "ERROR_MESSAGE": "Nem sikerült frissíteni az IMAP-beállításokat"
      },
      "ADDRESS": {
        "LABEL": "Cím",
        "PLACE_HOLDER": "Cím (pl. imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Bejelentkezés",
        "PLACE_HOLDER": "Bejelentkezés"
      },
      "PASSWORD": {
        "LABEL": "Jelszó",
        "PLACE_HOLDER": "Jelszó"
      },
      "ENABLE_SSL": "SSL engedélyezése"
    },
    "MICROSOFT": {
      "TITLE": "360Dialog",
      "SUBTITLE": "Engedélyezze újra MICROSOFT-fiókját"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "SMTP hozzáférés beállítása",
      "UPDATE": "SMTP beállítások frissítése",
      "TOGGLE_AVAILABILITY": "Engedélyezze az SMTP-konfigurációt ehhez a fiókhoz",
      "TOGGLE_HELP": "Az SMTP engedélyezése segít a felhasználónak az e-mailek küldésében",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP beállítások sikeresen frissítve",
        "ERROR_MESSAGE": "Nem sikerült frissíteni az SMTP-beállításokat"
      },
      "ADDRESS": {
        "LABEL": "Cím",
        "PLACE_HOLDER": "Cím (pl. smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Bejelentkezés",
        "PLACE_HOLDER": "Bejelentkezés"
      },
      "PASSWORD": {
        "LABEL": "Jelszó",
        "PLACE_HOLDER": "Jelszó"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Kódolás",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "SSL ellenőrzési mód megnyitása",
      "AUTH_MECHANISM": "Autentikáció"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "E-mailek kézbesíthetősége (DNS)",
      "SUB_TITLE": "Minden munkanapon ellenőrizzük a(z) {domain} SPF-, DKIM-, DMARC- és MX-rekordjait. Ha valami miatt a fogadó szerverek elutasítják vagy spamnek minősítik a válaszait, az adminisztrátorok e-mailt kapnak a javításról.",
      "RUN": "Ellenőrzés indítása",
      "RUN_SUCCESS": "A DNS-ellenőrzés befejeződött",
      "RUN_ERROR": "A DNS-ellenőrzést nem sikerült lefuttatni, kérjük, próbálja újra",
      "NOT_CHECKED": "Még nem volt ellenőrizve.",
      "CHECKED_AT": "Utoljára ellenőrizve: {time}.",
      "DNS_UNAVAILABLE": "Az utolsó ellenőrzés során a domain névszerverei nem válaszoltak. Az alábbi eredmény az előző ellenőrzésből származik.",
      "SENDER": {
        "SMTP": "A válaszok ezen keresztül mennek ki: {host}.",
        "PLATFORM": "A válaszok a mi levelezőszervereinken keresztül mennek ki."
      },
      "STATUS": {
        "OK": "Minden rekord rendben van",
        "WARNING": "Néhány rekord javítható",
        "ERROR": "A válaszok esetleg nem érkeznek meg a címzettekhez",
        "UNKNOWN": "Ismeretlen"
      },
      "SEVERITY": {
        "ERROR": "Hiba",
        "WARNING": "Figyelmeztetés"
      },
      "FIX": "Javítsa ezzel a DNS-rekorddal:",
      "RECORD_TYPE": "Típus",
      "RECORD_HOST": "Név",
      "RECORD_VALUE": "Érték",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Hiányzik az SPF-rekord",
          "DESCRIPTION": "A domain nem adja meg, hogy mely szerverek küldhetnek e-mailt a nevében. Sok levelezőszerver ezért spamnek tekinti a válaszait. Adjon hozzá egy SPF-rekordot, amely engedélyezi ezt: {sender}."
        },
        "spf_multiple": {
          "TITLE": "A domainnek {count} SPF-rekordja van",
          "DESCRIPTION": "Egy domainnek csak egy SPF-rekordja lehet. Ha több van, a fogadó szerverek figyelmen kívül hagyják az SPF-et, és gyakran elutasítják a levelet. Vonja össze őket egyetlen rekorddá."
        },
        "spf_not_authorized": {
          "TITLE": "Az SPF nem engedélyezi a válaszait küldő szervert",
          "DESCRIPTION": "A válaszai ezen keresztül mennek ki: {sender}, de a domain SPF-rekordja nem sorolja fel. Jelenlegi rekord: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Az SPF-rekordhoz túl sok DNS-lekérdezés kell",
          "DESCRIPTION": "A fogadó szerverek {limit} DNS-lekérdezés után leállnak az SPF ellenőrzésével, a válaszait küldő {sender} viszont csak {lookups} lekérdezés után következik. A válaszai ezért megbuknak az SPF-ellenőrzésen. Helyezze a(z) {sender} küldőt a rekord elejére, és távolítsa el az include elemeket, amelyeket a domain már nem használ."
        },
        "spf_lookups_others": {
          "TITLE": "Az SPF-rekord néhány küldője túllépi a lekérdezési korlátot",
          "DESCRIPTION": "Az SPF-rekordhoz {lookups} DNS-lekérdezés szükséges, a fogadó szerverek {limit} után leállnak. A válaszait még időben azonosítják, így azok megfelelnek, de az alábbi küldők levelei megbuknak az SPF-ellenőrzésen: {senders}. Távolítsa el az include elemeket, amelyeket a domain már nem használ."
        },
        "spf_malformed": {
          "TITLE": "Az SPF-rekord hibás",
          "DESCRIPTION": "A fogadó szerverek nem tudják beolvasni a domain SPF-rekordját, ezért az nem védi a válaszait. A hiba itt van: {terms}. Cserélje le a rekordot a javítottra."
        },
        "dkim_missing": {
          "TITLE": "A DKIM-aláírás nincs beállítva",
          "DESCRIPTION": "Nem találtunk DKIM-kulcsot itt: {selectors}. Nélküle a válaszai nincsenek aláírva, ezért nagyobb eséllyel kerülnek a spam mappába. Kapcsolja be a DKIM-aláírást a domainhez az e-mail-szolgáltatójánál."
        },
        "dmarc_missing": {
          "TITLE": "Hiányzik a DMARC-rekord",
          "DESCRIPTION": "A nagy levelezőszolgáltatók, például a Gmail és a Microsoft elvárják a DMARC-rekordot. Nélküle a válaszai nagyobb eséllyel kerülnek a spam mappába."
        },
        "dmarc_fails": {
          "TITLE": "A DMARC azt kéri a fogadóktól, hogy utasítsák el a válaszait",
          "DESCRIPTION": "A domain DMARC-szabálya „{policy}”, a válaszai pedig sem az SPF-en, sem a DKIM-en nem felelnek meg, ezért a fogadók elutasítják őket, vagy a spam mappába teszik. Javítsa a fenti SPF- és DKIM-problémákat."
        },
        "dmarc_blocks_platform": {
          "TITLE": "A DMARC blokkolja a mi levelezőszervereinken keresztül küldött válaszokat",
          "DESCRIPTION": "Ez a postaláda a mi levelezőszervereinken keresztül küldi a válaszokat, de a domain DMARC-szabálya „{policy}”, ezért a fogadók elutasítják őket, vagy a spam mappába teszik. Állítsa be ehhez a postaládához a saját levelezőszerverének SMTP-jét."
        },
        "mx_missing": {
          "TITLE": "A domainnek nincs MX-rekordja",
          "DESCRIPTION": "MX-rekord nélkül senki sem tud e-mailt küldeni a domainre, így az ügyfelek nem tudnak válaszolni a leveleire."
        }
      }
    },
    "NOTE": "Megjegyzés: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Weboldal avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar sikeresen törölve",
              "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website név",
          "PLACE_HOLDER": "Add meg weboldalad nevét (pl.: Példa Kft.)",
          "ERROR": "Kérlek, adj meg egy érvényes weboldal nevet"
        },
        "WELCOME_HEADING": {
          "LABEL": "Köszöntő fejléc üzenet",
          "PLACE_HOLDER": "Üdvözlünk!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Köszöntő üzenet",
          "PLACE_HOLDER": "Könnyűvé tesszük, hogy kapcsolatba kerülj velünk. Kérdezz bármit, vagy oszd meg véleményed."
        },
        "REPLY_TIME": {
          "LABEL": "Válaszidő",
          "IN_A_FEW_MINUTES": "Néhány percen belül",
          "IN_A_FEW_HOURS": "Néhány órán belül",
          "IN_A_DAY": "Egy napon belül"
        },
        "WIDGET_COLOR_LABEL": "Widget szín",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget buborék pozíciója",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Olvasatlan üzenetek maximális magassága (px)",
          "PLACE_HOLDER": "Nincs korlát",
          "HELP_TEXT": "Korlátozza az olvasatlan üzenetek felugró ablakának maximális magasságát pixelben. Hagyja üresen az alapértelmezett viselkedéshez (nincs korlát)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget buborék típusa",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatelj velünk",
          "LABEL": "Widget buborék indító címe",
          "PLACE_HOLDER": "Chatelj velünk"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Widget buborék beállításainak frissítése",
          "API": {
            "SUCCESS_MESSAGE": "Widget buborék beállítások sikeresen frissítve",
            "ERROR_MESSAGE": "Nem sikerült frissíteni a widget buborék beállításokat"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Előnézet",
          "SCRIPT": "Szkript"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Bal",
          "RIGHT": "Jobb"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Normál",
          "EXPANDED_BUBBLE": "Kiterjesztett widget buborék"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Alapértelmezett",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Néhány percen belül válaszol",
        "IN_A_FEW_HOURS": "Néhány órán belül válaszol",
        "IN_A_DAY": "Általánban egy napon belül válaszol"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Beszélgetés megkezdése",
        "CHAT_INPUT_PLACEHOLDER": "Gépeld be üzeneted"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Online vagyunk",
          "OFFLINE": "Jelenleg nem vagyunk elérhetőek"
        },
        "USER_MESSAGE": "Hello",
        "AGENT_MESSAGE": "Jó napot!"
      },
      "BRANDING_TEXT": "Üzemelteti: JARABOT",
      "SCRIPT_SETTINGS": "\nwindow.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "360Dialog",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Más szolgáltató"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Honlap",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brána",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API csatorna",
      "PHONE": "SIP telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
